import AxiosFactory from "@/repositories/AxiosFactory";

const resource = "/products/otk";

export default {
  getBalance(licenseId) {
    return AxiosFactory.get(`${resource}/balance/${licenseId}`);
  }
};
